// Actions relating to users
export const FORECAST_FETCH_START = "FORECAST_FETCH_START";
export const FORECAST_FETCH_SUCCESS = "FORECAST_FETCH_SUCCESS";
export const FORECAST_FETCH_FAILURE = "FORECAST_FETCH_FAILURE";
export const FORECAST_TOGGLE_DISPLAY_UNITS = "FORECAST_TOGGLE_DISPLAY_UNITS";
export const FORECAST_CHANGE_PAGE = "FORECAST_CHANGE_PAGE";
